<div *ngFor="let section of sections">
  <div id="{{ section.heading }}" [innerHTML]="section.body | mdToHtml"></div>
  <details class="pt-3 pb-5" *ngIf="section.xmlData">
    <summary>
      {{ section.xmlTitle }}
    </summary>
    <div class="xml-content">
      <app-prism-xml [xmlData]="section?.xmlData"></app-prism-xml>
    </div>
  </details>
  <div *ngIf="section.subBody" [innerHTML]="section.subBody || '' | mdToHtml"></div>
</div>
